// queries/useEventTracking.ts
"use client";
import { useMutation } from "@tanstack/react-query";
import { PageViewData } from "types";
import { fetch } from "libs";
import { POST_PAGE_VIEW } from "api";

const fetchEventTracking = ({ event_id, event_name, data }: PageViewData): Promise<any> => {
  return fetch(POST_PAGE_VIEW, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      event_id: event_id ? event_id : "",
      event_name: event_name,
      data: data,
    }),
  });
};

const useEventTracking = () => {
  return useMutation({
    mutationFn: async ({ event_id, event_name, data }: PageViewData) => {
      const res = await fetchEventTracking({ event_id, event_name, data });
      return res;
    },
    onSuccess: () => {
      console.log("Event tracking successful");
    },
    onError: (error) => {
      console.error("Error in useEventTracking:", error);
    },
  });
};

export default useEventTracking;
